import React, {useEffect} from 'react'
import UiInputText from "../components/Form/UiInputText";
import UiInputList from "../components/Form/UiInputList";
import UiInputCheckbox from "../components/Form/UiInputCheckbox";
import UiGridForm from "../components/Form/UiGridForm";
import Form from "../components/Form/Form";
import {useForm, FormProvider} from "react-hook-form";
import WindowBody from '../components/Window/WindowBody';
import WindowFooter from '../components/Window/WindowFooter';
import { UiButton } from '../components/UiButton';

const tipoList = [
    { id: 'texto', title: 'Texto' },
    { id: 'numero', title: 'Número' },
    { id: 'booleano', title: 'Sim/Não' },
    { id: 'lista', title: 'Lista de Opções' },
];

const toDefaults = (data: any) => {
    if (!data) return { ativo: true, tipo: 'texto', opcoesList: [] };
    return {
        ...data,
        opcoesList: Array.isArray(data.opcoes) ? data.opcoes.map((valor: any) => ({ valor })) : []
    };
};

export default function CaracteristicaForm(props: any){
    const methods = useForm({
        defaultValues: toDefaults(props.data)
    });
    const { handleSubmit, reset, watch } = methods;

    useEffect(() => {
        if (props.data) {
            reset(toDefaults(props.data));
        }
    }, [props.data, reset]);

    const tipo = watch('tipo');
    const tipoAlterado = props.data?.id && props.data?.tipo && tipo !== props.data.tipo;

    const onSubmit = (dados: any) => {
        const { opcoesList, ...resto } = dados;
        if (resto.tipo === 'lista') {
            resto.opcoes = (opcoesList || [])
                .map((item: any) => item?.valor)
                .filter((valor: any) => valor !== undefined && valor !== null && String(valor).trim() !== '');
        }
        props.triggerSubmit(resto);
    };

    return (
        <FormProvider {...methods}>
            <Form onSubmit={handleSubmit(onSubmit)} methods={methods}>
                <WindowBody>
                    <div className="row">
                        <UiInputText size={6} name="nome" label="Nome"/>
                        <UiInputText size={6} name="slug" label="Slug" placeholder="gerado automaticamente"/>
                        <UiInputList size={4} name="tipo" list={tipoList} idField="id" titleField="title" label="Tipo"/>
                        { tipo === 'numero' &&
                            <UiInputText size={4} name="unidade" label="Unidade"/>
                        }
                        <UiInputCheckbox size={4} name="ativo" label="Ativo"/>
                    </div>

                    { tipoAlterado &&
                        <div className="row">
                            <div className="col-lg-12">
                                <small className="text-muted">Alterar o tipo revalida os valores já gravados; nada é apagado.</small>
                            </div>
                        </div>
                    }

                    { tipo === 'lista' &&
                        <div className="row">
                            <UiGridForm name="opcoesList" label="Opções da Lista">
                                <UiInputText size={12} name="valor" label="Opção"/>
                            </UiGridForm>
                        </div>
                    }
                </WindowBody>

                <WindowFooter>
                    <UiButton variant="secondary" onClick={props.triggerClose}>Fechar</UiButton>
                    <UiButton variant="primary" type="submit">Salvar</UiButton>
                </WindowFooter>
            </Form>
        </FormProvider>
    )
}
